import { Avatar, Col, Drawer, Dropdown, Layout, Menu, Row } from "antd"
import React, { useContext, useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"
import STORAGE, { clearStorage, getStorage, setStorage } from "src/lib/storage"
import { StoreContext } from "src/lib/store"
import UseWindowSize from "src/lib/useWindowSize"
import { hasPermission } from "src/lib/utils"
import { setUserInfo } from "src/redux/appGlobal"
import ROUTER from "src/router"
import AuthService from "src/services/AuthService"
import LayoutCommon from "../Common/Layout"
import LayoutAdminCommon from "../Common/LayoutAdmin"
import SvgIcon from "../SvgIcon"
import { MenuItem, MenuItemAdmin } from "./MenuItems"
import Notification from "./component/Notification"
import { CustomMenuStyled, LayoutStyled, StyleMenuAccount } from "./styled"
import "./styles.scss"
import LayoutAdmin from "./component/LayoutAdmin"

const { Header, Content } = Layout

const MainLayout = ({ children, isAdmin, isUser }) => {
  const { listTabs, userInfo } = useSelector(state => state?.appGlobal)
  const isLogin = getStorage(STORAGE.TOKEN)
  const isTime = getStorage(STORAGE.EXP_TIME)
  const isInfo = getStorage(STORAGE.USER_INFO)
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch()
  const [selectedKey, setSelectedKey] = useState(
    getStorage(STORAGE.KEY_MENU_ACTIVE) || ["/"],
  )
  const [openUserInfor, setOpenUserInfor] = useState(false)
  const { isNotificationUpdate } = useContext(StoreContext)
  const [isModelNotification, setIsModelNotification] = isNotificationUpdate
  const currentTime = Date.now();
  const [selectedKeyAdmin, setSelectedKeyAdmin] = useState()
  let isManagerPage = location.pathname.includes(ROUTER.QUAN_LY_TAI_KHOAN)
  useEffect(() => {
    let key = location?.pathname
    setSelectedKey([key])
    setSelectedKeyAdmin([key])

  }, [location])
  useEffect(() => {
    if (!!isTime && isTime < currentTime) {
      handleLogout();
    }
  }, [isTime, currentTime]);
  const onClickMenu = key => {
    if (isModelNotification) {
      setIsModelNotification(false)
    }
    setStorage(STORAGE.KEY_MENU_ACTIVE, key.keyPath)
    setSelectedKey(key.key.keyPath)
    if (!key.key.includes("subkey")) navigate(key.key)
  }
  const onClickMenuAdmin = key => {
    setSelectedKeyAdmin(key.key.keyPath)
    if (!key.key.includes("subkey")) navigate(key.key)
  }
  const handleLogout = async () => {
    try {
      if (isLogin) {

        let res = await AuthService.logout('', {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer${isLogin}`, // Thêm token vào header
          }
        })
        clearStorage()
        dispatch(setUserInfo({}))
        return navigate(ROUTER?.DANG_NHAP)

      }
    } catch (error) {
      clearStorage()
      dispatch(setUserInfo({}))
      return navigate(ROUTER?.DANG_NHAP)
    }



  }

  const menuAccount = (
    <StyleMenuAccount>
      <div className="menu-account">
        <Menu className="dropdown-option">
          <div className="account-infor">
            <Menu.Item
              key="3"
              onClick={() => {
                navigate(ROUTER.ACCOUNT)
                // setOpenUserInfor(true)
              }}
            >
              <div className="btn-function strok-btn-function">
                <SvgIcon name="user-info" />
                <span className="fw-400">Thông tin tài khoản</span>
              </div>
            </Menu.Item>
            <Menu.Item
              key="4"
              onClick={() => {
                navigate(ROUTER.DOI_MAT_KHAU)
              }}
            >
              <div className="btn-function strok-btn-function">
                <SvgIcon name="reset-pass" />
                <span className="fw-400">Đổi mật khẩu</span>
              </div>
            </Menu.Item>
            <Menu.Item
              key="3"
              onClick={() => {
                navigate(ROUTER.QUAN_LY_DIEN_TAP)
              }}
            >
              <div className="btn-function strok-btn-function">
                <SvgIcon name="user-info" />
                <span className="fw-400">Quản trị hệ thống</span>
              </div>
            </Menu.Item>
            <Menu.Item
              key="5"
              style={{ color: "#ED1117" }}
              onClick={handleLogout}
            >
              <div className="btn-logout">
                <SvgIcon name="logoutIcon" />
                Đăng xuất
              </div>
            </Menu.Item>
          </div>
        </Menu>
      </div>
    </StyleMenuAccount>
  )

  const setShowListMenu = list =>
    !!list?.length
      ? list
        ?.filter(
          x => hasPermission(x?.TabID, [...listTabs]) || x.publishRouter,
        )
        .map(i => ({
          ...i,
          children: setShowListMenu(i?.children),
        }))
      : undefined

  return (
    <LayoutStyled styleBackground={isManagerPage}>
      {/* css ẩn menu đi */}

      <Layout>
        <Row className="admin-style">
          {!!isAdmin ?
            <>
              <LayoutAdmin
                children={children}
                menuAdmin={MenuItemAdmin().filter(i => i.publishRouter)}
                selectedKey={selectedKeyAdmin}
              />
              {/* <Menu
                  defaultSelectedKeys={['1']}
                  defaultOpenKeys={['sub1']}
                  selectedKeys={selectedKeyAdmin}
                  onClick={key => onClickMenuAdmin(key)}
                  mode="inline"
                  theme="light"
                  // inlineCollapsed={collapsed}
                  items={MenuItemAdmin().filter(i => i.publishRouter)}
                /> */}
            </>
            :
            <Content className="site-layout-background w-100">
              <div
                className="w-100"
                style={{ minHeight: "calc(100vh - 105px)" }}
              >
                <LayoutCommon>{children}</LayoutCommon>
              </div>
              {/* <Footer /> */}
            </Content>
          }

        </Row>

      </Layout>
    </LayoutStyled>
  )
}

export default MainLayout
